// extracted by mini-css-extract-plugin
export default {"body":"jewelery_body__XXTa2","loader":"jewelery_loader__o6bdB","pgfill":"jewelery_pgfill__JX+hD"};